import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { usePlayerPause, usePlayerStore } from '@air/component-player';

import { useCurrentPlayerTimeGetter } from '~/components/AnnotationsV2/hooks/useCurrentPlayerTimeGetter';
import { type CommentRange, useAnnotationV2Store } from '~/components/AnnotationsV2/providers/AnnotationV2Provider';
import { centralizedClipTypeSelector } from '~/store/centralizedClip/selectors';

const hasSelectedCommentRange = (commentRange: CommentRange | null) =>
  !!commentRange && commentRange.startTime !== commentRange.endTime;

export const useEnableCommentRange = () => {
  const clipType = useSelector(centralizedClipTypeSelector);
  const playing = usePlayerStore((state) => state.playing);
  const { onPlayerPause } = usePlayerPause();
  const commentRange = useAnnotationV2Store((state) => state.commentRange);
  const setCommentRangeEnabled = useAnnotationV2Store((state) => state.setCommentRangeEnabled);
  const setCommentRange = useAnnotationV2Store((state) => state.setCommentRange);
  const { getCurrentPlayerTime } = useCurrentPlayerTimeGetter();

  const enableCommentRange = useCallback(() => {
    if (clipType !== 'video' || hasSelectedCommentRange(commentRange)) {
      return;
    }

    if (playing) {
      onPlayerPause();
    }

    const playhead = getCurrentPlayerTime();

    setCommentRangeEnabled(true);
    setCommentRange({ startTime: playhead, endTime: playhead });
  }, [clipType, commentRange, getCurrentPlayerTime, onPlayerPause, playing, setCommentRange, setCommentRangeEnabled]);

  return { enableCommentRange };
};
